// src/lib/useDpcAgg.ts (2026-09-28 ユーザ指示)
// DPC分析タブの件数・金額を「期間累計」か「月平均」で統一して出すための共通部品。
// 主表・サマリ行・ICD別・実績K表が同じ分母を使う (= 主表と同じ「データのある月数」monthsEffective)。
// 以前は主表が月平均、ICD別/実績K表が期間累計で、同じ画面で数字が食い違って見えていた。
import { useFilters } from "../store";
import { useDiseaseRanking } from "./useDiseaseRanking";
import { fmt1, fmtInt } from "./format";

export function useDpcAgg() {
  const f = useFilters();
  const { data } = useDiseaseRanking();   // react-query キャッシュ共有 (追加 fetch なし)
  const months = Math.max(1, data?.monthsEffective ?? data?.months ?? 1);
  const isAvg = f.dpcAgg === "月平均";
  const div = isAvg ? months : 1;
  return {
    isAvg,
    div,
    months,
    label: isAvg ? "月平均" : "期間累計",
    /** 件数: 累計は整数、月平均は小数 1 桁 */
    fmtCount: (n: number | null | undefined) =>
      n == null || !Number.isFinite(n) ? "—" : isAvg ? fmt1(n / months) : fmtInt(n),
    /** ホバー用の説明 (累計 ↔ 月平均 の換算) */
    note: (n: number, unit: string) => isAvg
      ? `期間累計 ${fmtInt(n)} ${unit} ÷ データのある ${months} ヶ月`
      : `月平均 ${fmt1(n / months)} ${unit} (= ÷ データのある ${months} ヶ月)`,
  };
}
